import { toast } from "react-toastify";
import { io } from "socket.io-client";

const SOCKET_SERVER_URL = process.env.REACT_APP_SOCKET_URL;

let socket;

export const connectSocket = (userId, connectionLost, onConnection) => {
  if (!socket || socket?.disconnected) {
    socket = io(SOCKET_SERVER_URL, {
      reconnection: true,
      reconnectionAttempts: 20,
      reconnectionDelay: 4000,
      timeout: 5000,
      pingInterval: 2000,
      pingTimeout: 1000,
    });

    socket.on("connected", (data) => {
      onConnection?.();
      socket.emit("registerUser", userId);
    });
    socket.on("messageToUser", (data) => {
      toast.success(data);
    });

    socket.on("disconnect", (reason) => {
      if (!navigator.onLine) {
        console.warn("Internet connection lost!");
        connectionLost?.();
      } else {
        console.warn("Socket disconnected due to:", reason);
      }
    });

    socket.on("reconnect_failed", () => {
      console.warn("All reconnection attempts failed.");
    });
  }

  return socket;
};

export const getSocket = () => socket;

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};
